<template>
    <div v-bind="$attrs" class="rounded-md bg-red-50 p-4">
        <div class="flex items-start justify-between">
            <div class="text-sm text-red-700 gap-2">
                <div class="flex rounded bg-red-100 px-2 py-1 gap-2">
                    <div class="shrink-0">
                        <ExclamationTriangleIcon class="w-5 h-5 text-red-400" aria-hidden="true" />
                    </div>
                    <p class="text-sm text-red-700 truncate max-w-[25vw]">{{ introductionText }}</p>
                </div>
            </div>
            <button class="ml-4 text-md text-red-700 underline whitespace-nowrap" @click="onViewDetailsClick">View details</button>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import useErrorDialog from '../composables/useErrorDialog.js';
import SentryService from '../services/sentry.service';
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid';

const defaultIntro = 'An error occured.';
const props = defineProps({
    error: {
        required: true
    },
    toSentry: {
        type: Boolean,
        default: false
    },
    context: {
        type: String,
        default: ''
    },
    introduction: {
        type: String,
        default: defaultIntro
    }
});

const parsedError = computed(() => {
    console.log('ErrorMessage.vue: parsedError', props.error);
    if (typeof props.error === 'string') return props.error;
    return props.error?.response?.data?.error || props.error?.response?.data?.detail || props.error?.message || String(props.error);
});

const introductionText = computed(() => {
    return props.introduction === defaultIntro && parsedError.value ? parsedError.value : props.introduction;
});

onMounted(() => {
    if (props.toSentry && parsedError.value) {
        SentryService.notify(new Error(parsedError.value), {
            severity: 'error',
            context: props.context
        });
    }
});

function onViewDetailsClick() {
    useErrorDialog({ errors: [parsedError.value] });
}
</script>
